export enum MarketingConsentType {
    MESSENGER = 'MESSENGER',
    PHONE_CALL = 'PHONE_CALL',
    EMAIL = 'EMAIL',
    PUSH = 'PUSH',
}

export type MarketingConsent = {
    consentType: MarketingConsentType;
    isSigned: boolean;
};

export const DEFAULT_MARKETING_CONSENT_LIST = Object.getOwnPropertyNames(
    MarketingConsentType,
).map((consentType) => ({
    consentType,
    isSigned: false,
})) as MarketingConsent[];
